import { render, staticRenderFns } from "./SessionAgilizaEvDetailModal.vue?vue&type=template&id=2af8d9b3&scoped=true"
import script from "./SessionAgilizaEvDetailModal.vue?vue&type=script&lang=js"
export * from "./SessionAgilizaEvDetailModal.vue?vue&type=script&lang=js"
import style0 from "./SessionAgilizaEvDetailModal.vue?vue&type=style&index=0&id=2af8d9b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8d9b3",
  null
  
)

export default component.exports